<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">play_circle_outline</mat-icon>
    <span class="section-title">{{ 'general.preview' | transloco }}</span>
    <button mat-icon-button class="close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">play_arrow</mat-icon>
                {{ 'general.play' | transloco }}
            </ng-template>
            <div class="preview-wrapper">
                <div class="previewSceneLeft">
                    <div class="d-flex-center">
                        @if (!data.isSlider) {
                            <app-scene-selector
                                [currentSceneId]="data.selectedSceneId"
                                [currentSceneName]="'current scene'"
                                [selectedSceneId]="previewSceneId"
                                [showJump]="true"
                                (changeSelectedScene)="changePreviewScene($event)">
                            </app-scene-selector>
                        } @else {
                            <span style="font-weight: bold;">{{ data.sliderName | PipeTruncate:['25'] }} (Slider Preview)</span>
                        }
                    </div>
                    <mat-radio-group [(ngModel)]="previewMode" (ngModelChange)="onPreviewModeChange()">
                        <mat-radio-button value="size">
                            <div [ngClass]="{'not-active': previewMode != 'size'}">
                                <mat-form-field class="custom-size-field">
                                    <mat-label>{{ 'general.width' | transloco }}</mat-label>
                                    <input inputrestriction="basic1" matInput type="number" max="7680"
                                           [(ngModel)]="previewSizeX"
                                           (ngModelChange)="onPreviewSizeChange()" placeholder="" autocomplete="off">
                                </mat-form-field>
                                <mat-form-field class="custom-size-field">
                                    <mat-label>{{ 'general.height' | transloco }}</mat-label>
                                    <input inputrestriction="basic1" matInput type="number" max="7680"
                                           [(ngModel)]="previewSizeY"
                                           (ngModelChange)="onPreviewSizeChange()" placeholder="" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </mat-radio-button>
                        <br />
                        <mat-radio-button value="percent">
                            <div [ngClass]="{'not-active': previewMode != 'percent'}">
                                <mat-form-field class="custom-size-field">
                                    <mat-label>{{ 'general.percent' | transloco }}</mat-label>
                                    <mat-select [(ngModel)]="previewPercent" (ngModelChange)="onPreviewPercentChange()">
                                        @for (p of percentages; track p) {
                                            <mat-option [value]="p">{{ p }}%</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="previewSceneRight">
                    <div class="embeddedDialog2" fxLayout="column" fxLayoutAlign="start start">
                        @if (data.isMainScene) {
                            <button class="icon-button buttonBarButt" mat-raised-button (click)="onRegisterPlayer()">
                                <mat-icon class="buttonBarIcon">queue_play_next</mat-icon>&nbsp;&nbsp;
                                {{ 'general.registerPlayer' | transloco }}
                            </button>
                            <br />
                        }
                        <button class="icon-button buttonBarButt" mat-raised-button (click)="onWebEmbedded()">
                            <mat-icon class="buttonBarIcon">code</mat-icon>&nbsp;&nbsp;
                            {{ 'general.webEmbedded' | transloco }}
                        </button>
                        <br />
                        <button class="icon-button buttonBarButt" mat-raised-button (click)="onCopyLink()">
                            <mat-icon class="buttonBarIcon">content_copy</mat-icon>&nbsp;&nbsp;
                            {{ 'general.copyLink' | transloco }}
                        </button>
                        <br />
                        <button class="buttonBarButt" mat-raised-button (click)="onQrCode()">
                            <mat-icon class="buttonBarIcon">qr_code_scanner</mat-icon>&nbsp;&nbsp;
                            {{ 'general.qrCode' | transloco }}
                        </button>
                        <br>
                        <mat-checkbox [(ngModel)]="rememberSelection"
                                      (change)="changeRemeberSelection()">{{ 'account.rememberMe' | transloco }}
                        </mat-checkbox>
                        <br>
                    </div>
                </div>
                <div class="clearFloat">
                </div>

                <div style="text-align: center;">
                    <button color="warn" class="previewButton" mat-raised-button (click)="onClickPlayPreview()"
                            [disabled]="(!previewSizeX || !previewSizeY || previewSizeX < 100 || previewSizeY < 100) && previewMode === 'size' ">
                        <mat-icon class="buttonBarIcon">play_circle_outline</mat-icon>&nbsp;&nbsp;
                        {{ 'general.webPreview' | transloco }}
                    </button>
                </div>

                @if (!data.isMainScene) {
                    <div style="text-align: center;">
                        <br />
                        <span class="color-warning" style="font-weight: bold">{{ 'general.warning' | transloco }}
                            for {{ data.sceneMimeShort }} Scene</span><br />
                        <span>
                    {{ 'general.previewSpecial' | transloco }}
                  </span>
                    </div>
                }
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">track_changes</mat-icon>
                {{ 'general.socialMedia' | transloco }}
            </ng-template>
            <div class="social-media-wrapper">
              <span>
                post scene [{{ data.sceneData.Player.$.label }}] to your favorite social network
              </span>
                <div class="d-flex inline-flex flex-lt-md-col">
                    <div class="media-group">
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'youtube')">
                            <fa-icon size="xl" [icon]="['fab', 'youtube']"></fa-icon>
                            <span class="social-name">Youtube</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'twitter')">
                            <fa-icon size="xl" [icon]="['fab', 'twitter']"></fa-icon>
                            <span class="social-name">X</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'facebook')">
                            <fa-icon size="xl" [icon]="['fab', 'facebook']"></fa-icon>
                            <span class="social-name">FaceBook</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'gmb')">
                            <fa-icon size="xl" [icon]="['fab', 'google-drive']"></fa-icon>
                            <span class="social-name">Google Business</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'tiktok')">
                            <fa-icon size="xl" [icon]="['fab', 'tiktok']"></fa-icon>
                            <span class="social-name">TikTok</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'reddit')">
                            <fa-icon size="xl" [icon]="['fab', 'reddit']"></fa-icon>
                            <span class="social-name">Reddit</span>
                        </mat-checkbox>
                    </div>
                    <div class="media-group">
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'telegram')">
                            <fa-icon size="xl" [icon]="['fab', 'telegram']"></fa-icon>
                            <span class="social-name">Telegram</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'linkedin')">
                            <fa-icon size="xl" [icon]="['fab', 'linkedin']"></fa-icon>
                            <span class="social-name">LinkedIn</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'instagram')">
                            <fa-icon size="xl" [icon]="['fab', 'instagram']"></fa-icon>
                            <span class="social-name">Instagram</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'fbg')">
                            <fa-icon size="xl" [icon]="['fab', 'facebook']"></fa-icon>
                            <span class="social-name">FaceBook Groups</span>
                        </mat-checkbox>
                        <mat-checkbox (change)="selectSocialMedia($event.checked, 'pinterest')">
                            <fa-icon size="xl" [icon]="['fab', 'pinterest']"></fa-icon>
                            <span class="social-name">Pinterest</span>
                        </mat-checkbox>
                    </div>
                </div>
                <br>
                <div class="d-flex inline-flex flex-lt-md-col" fxLayoutGap="64px">
                    <div fxFlex fxLayout="column">
                        <mat-form-field>
                            <mat-label>{{ 'general.text' | transloco }}</mat-label>
                            <input (change)="isSocialPostReady()" (keyup)="isSocialPostReady()"
                                   [(ngModel)]="socialMediaTitle" inputrestriction="basic2" matInput type="text"
                                   placeholder="" autocomplete="off">
                        </mat-form-field>
                        <div class="d-flex-center">
                            <mat-form-field style="margin-right: 10px;">
                                <mat-label>{{ 'general.resource' | transloco }}</mat-label>
                                <input readonly matInput type="text" [(ngModel)]="socialMediaResourceName">
                            </mat-form-field>
                            <button mat-icon-button class="mini-button"
                                    matTooltip="{{'general.addResource' | transloco}}" (click)="selectResource()">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div fxFlex fxLayout="column" fxLayoutGap="32px" style="position: relative; left: -40px; top: 10px">
                        <app-scene-social-token #appSceneSocialTokenApp [miniMode]="true"
                                                (changed)="onSocialKeyChanged($event)"></app-scene-social-token>
                        @if (socialPosting) {
                            <div>
                                <app-loading [size]="'20px'"></app-loading>
                            </div>
                        }
                        @if (!socialPosting) {
                            <button color="accent" [disabled]="socialPostDisabled" class="icon-button buttonBarButt"
                                    mat-raised-button (click)="postToSocial()">
                                <mat-icon class="buttonBarIcon">content_copy</mat-icon>&nbsp;&nbsp;
                                {{ 'general.postToSocial' | transloco }}
                            </button>
                        }
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
